import { appurl } from './../../../../../../environments/environment';
import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ClipboardService } from '../../../../../service/clipboard.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'app-share-asset',
    standalone: false,
    templateUrl: './share-asset.component.html',
    styleUrl: './share-asset.component.scss'
})
export class ShareAssetComponent implements OnInit {
    dialogRef = inject(MatDialogRef<ShareAssetComponent>);
    clipboardService = inject(ClipboardService);
    private destroyRef = inject(DestroyRef);

    data = inject<{ streamId: string | undefined, stepId: string | undefined, userId: string | undefined }>(MAT_DIALOG_DATA);
    appurl = appurl;
    resultmsg: string = '';
    resulttype: 'success' | 'error' = 'success';

    ngOnInit(): void {
        this.dialogRef.keydownEvents()
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe({
                next: (event) => {
                    if (event.key === 'Enter') {
                        event.preventDefault();
                        this.close();
                    }
                },
            });
    }

    get shareLink(): string {
        let userIdComponent = this.data.userId ? `?uid=${this.data.userId}&` : '?';
        return `${this.appurl}/generic-stream/published/view${userIdComponent}sid=${this.data.streamId}&stepid=${this.data.stepId}`;
    }

    async copyToClipboard() {
        let result = await this.clipboardService.easyCopyToClipboard(this.shareLink);
        if (result === true) {
            this.resultmsg = 'Link copied to clipboard!';
            this.resulttype = 'success';
        } else {
            this.resultmsg = 'Copying to clipboard failed. Please copy the link manually.';
            this.resulttype = 'error';
        }
    }
    async openLink() {
        window.open(this.shareLink, '_blank');
    }

    protected close(): void {
        this.dialogRef.close();
    }

}

